import styled from '@emotion/styled';

export const CardsListContainer = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-gap: 2px;
`;
